/*
 * @Descripttion:
 * @Author: juanjuanhui
 * @Date: 2021-12-09 18:09:46
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2021-12-23 14:17:07
 */
const state = {
  kName: "",
  showTrajectory: false, // 是否显示轨迹
  palyBtnName: "start", // 轨迹播放状态名称
  trajectoryPlay: { workId: "", show: false }, // 轨迹播放信息
  machineCategoryId3: "", // 演示期间临时使用字段
};
const mutations = {
  changeShowTrajectory(state, payload) {
    state.showTrajectory = payload;
  },
  changeBtnName(state, payload) {
    state.palyBtnName = payload;
  },
  changeTrajectoryPlay(state, payload) {
    state.trajectoryPlay = payload;
  },
  changeMachineCategoryId3(state, payload) {
    state.machineCategoryId3 = payload;
  },
};
const actions = {
  changeShowTrajectory({ commit }, data) {
    commit("changeShowTrajectory", data);
  },
  changeBtnName({ commit }, data) {
    commit("changeBtnName", data);
  },
  changeTrajectoryPlay({ commit }, data) {
    commit("changeTrajectoryPlay", data);
  },
  changeMachineCategoryId3({ commit }, data) {
    commit("changeMachineCategoryId3", data);
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
